import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deletePoliciesFailed, deletePoliciesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deletePolicies(action) {
  try {
    const url = `${BACKEND_URL}/policies/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deletePoliciesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deletePoliciesFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deletePoliciesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
